import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';

import TopStrip from '../components/TopStrip';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import HelpButton from '../components/HelpButton';
import OfferPopup from '../components/OfferPopup';
import TestimonialsCarousel from '../components/TestimonialsCarousel';

// herobanner imports
import slide1 from '../assets/images/hero-banners/slide-1.webp';
import slide2 from '../assets/images/hero-banners/slide-2.webp';
import slide3 from '../assets/images/hero-banners/slide-3.webp';
import slide4 from '../assets/images/hero-banners/slide-6.webp';
import slide5 from '../assets/images/hero-banners/slide-7.webp';
import slide6 from '../assets/images/hero-banners/slide-5.webp';
import slide7 from '../assets/images/hero-banners/slide-4.webp';

import mslide1 from '../assets/images/hero-banners/mobile/slide-1-mobile.webp';
import mslide2 from '../assets/images/hero-banners/mobile/slide-2-mobile.webp';
import mslide3 from '../assets/images/hero-banners/mobile/slide-3-mobile.webp';
import mslide4 from '../assets/images/hero-banners/mobile/slide-6-mobile.webp';
import mslide5 from '../assets/images/hero-banners/mobile/slide-7-mobile.webp';
import mslide6 from '../assets/images/hero-banners/mobile/slide-5-mobile.webp';
import mslide7 from '../assets/images/hero-banners/mobile/slide-4-mobile.webp';
// card logos
import card1 from '../assets/images/card-logo/1.png';
import card2 from '../assets/images/card-logo/2.png';
import card3 from '../assets/images/card-logo/3.png';
import card4 from '../assets/images/card-logo/4.png';
import card5 from '../assets/images/card-logo/5.png';
import card6 from '../assets/images/card-logo/6.png';

// 3rd cardslider
import monitor from '../assets/images/3rd-card-slider/Monitoring.1.png';
import thunder from '../assets/images/3rd-card-slider/thunder.2.png';
import lock from '../assets/images/3rd-card-slider/lock.3.png';
import img4 from '../assets/images/3rd-card-slider/4.png';
import img5 from '../assets/images/3rd-card-slider/5.png';
import img6 from '../assets/images/3rd-card-slider/6.png';

// other sections
import hostingPartner from '../assets/images/hosting-partner-image.png';
import devopsImg from '../assets/images/webp-images/image (1).jpeg';
import phpTab from '../assets/images/tab-images/php1.webp';
import meanTab from '../assets/images/tab-images/2.webp';
import javaTab from '../assets/images/tab-images/3.webp';
import pythonTab from '../assets/images/tab-images/4.webp';
import contactGif from '../assets/images/homePage-animation-contactForm.gif';

// Logo slide
import logo1 from '../assets/images/logo-slide/1.avif';
import logo2 from '../assets/images/logo-slide/2.avif';
import logo3 from '../assets/images/logo-slide/3.avif';
import logo4 from '../assets/images/logo-slide/4.avif';
import logo5 from '../assets/images/logo-slide/5.avif';
import logo6 from '../assets/images/logo-slide/6.avif';
import logo7 from '../assets/images/logo-slide/7.avif';
import logo8 from '../assets/images/logo-slide/8.avif';
import logo9 from '../assets/images/logo-slide/9.avif';

const heroSlides = [
  { desktop: slide1, mobile: mslide1, link: '/about', alt: 'DDevOps Engineering Future Cloud Infrastructure Solutions' },
  { desktop: slide2, mobile: mslide2, link: '/devops-services', alt: 'Automated CI/CD Pipelines for Zero Downtime Deployment' },
  { desktop: slide3, mobile: mslide3, link: '/devsecops-services', alt: 'DevSecOps Automated Threat Detection and Security Shield' },
  { desktop: slide4, mobile: mslide4, link: '/managed-services', alt: 'Managed IT Operations. Simplified.' },
  { desktop: slide5, mobile: mslide5, link: '/development-services', alt: 'Vision to Reality. Accelerated.' },
  { desktop: slide6, mobile: mslide6, link: '/technology-partnership', alt: 'Enterprise Technology Consulting and R&D Partnership' },
  { desktop: slide7, mobile: mslide7, link: '/whitelabel-solution', alt: 'Whitelabel DevOps Team for Agencies and Hosting Companies' },
];

const featureCards = [
  { img: card1, title: 'Infrastructure as Code', desc: 'We eliminate human error. From Terraform to Ansible, we script your environments for perfect reproducibility.' },
  { img: card2, title: 'Silo-Free Engineering', desc: 'We bridge the gap between Development and Operations, ensuring your teams speak the same language for faster problem solving.' },
  { img: card3, title: 'Predictive Observability', desc: 'We don\'t just watch screens; we use proactive alerts (Prometheus/Grafana) to fix issues before your users notice.' },
  { img: card4, title: 'Shift-Left Quality', desc: 'We integrate automated testing into the pipeline, catching bugs before they ever reach production.' },
  { img: card5, title: 'Commit with Confidence', desc: 'Automated builds and merges mean your developers can push code daily, not monthly.' },
  { img: card6, title: 'One-Click Deployments', desc: 'Release new features to your users instantly and safely, with zero downtime strategies.' },
];

const engineeringCards = [
  { img: monitor, title: 'Self-Healing Infrastructure', desc: 'We don\'t just watch screens. Our automated monitoring detects crashes instantly and triggers auto-healing scripts to restore services without human intervention.' },
  { img: thunder, title: 'Performance-Optimized Stacks', desc: 'Speed converts. We deploy custom-tuned stacks (PHP, Java, MEAN) optimized for your specific workload, boosting application response times by up to 90%.' },
  { img: lock, title: 'Zero-Trust Access Control', desc: 'Say goodbye to shared root passwords. We implement secure GUI management and encrypted tunnels, ensuring only the right people have access to your mission-critical data.' },
  { img: img4, title: 'Automated Compliance & Patching', desc: 'Never miss a security update. We automate the patching process for your OS and software, keeping your infrastructure hardened against the latest vulnerabilities.' },
  { img: img5, title: 'DevSecOps & Threat Mitigation', desc: 'Security isn\'t a feature; it\'s our baseline. We implement fortified protocols to shield your data from internal leaks and external attacks before they happen.' },
  { img: img6, title: 'High-Availability Architecture', desc: 'Downtime is obsolete. We architect multi-tier, load-balanced environments with geo-redundancy, ensuring your application survives traffic spikes and server failures.' },
];

const logoImages = [logo1, logo2, logo3, logo4, logo5, logo6, logo7, logo8, logo9];

const tabData = [
  {
    id: 'php', label: 'PHP / Laravel (The Speed Layer)',
    img: phpTab, altImg: 'PHP Stack',
    content: <><strong>The 100ms Benchmark</strong> We don't just install Apache. We layer Nginx as a reverse proxy, Varnish for HTTP caching, and Redis for object caching. The result? PHP applications that handle 10x the traffic of a standard LAMP stack.</>
  },
  {
    id: 'mean', label: 'Mean / Mern (The Async Layer)',
    img: meanTab, altImg: 'MEAN Stack',
    content: <><strong>Node.js at Scale</strong> Specialized PM2 process management and Nginx load balancing ensure your single-threaded event loop never gets blocked, even under massive concurrency.</>
  },
  {
    id: 'java', label: 'Java / Spring (The Enterprise Layer)',
    img: javaTab, altImg: 'Java Stack',
    content: <><strong>JVM Optimization</strong> Custom Heap memory tuning and Garbage Collection strategies tailored to your application's footprint, ensuring stability for long-running enterprise processes.</>
  },
  {
    id: 'python', label: 'Python (Django / Flask)',
    img: pythonTab, altImg: 'Python Stack',
    content: <>We fix <b>Python's concurrency</b> limits using optimized uWSGI/Gunicorn setups with Nginx. Celery offloads intensive tasks for smooth, non-blocking performance. With tuned PostgreSQL, your Django or Flask app scales effortlessly under heavy traffic.</>
  },
];

// Counter animation hook
function useCounter(target, inView) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!inView) return;
    let current = 0;
    const inc = target / 100;
    const timer = setInterval(() => {
      current += inc;
      if (current >= target) {
        setCount(target);
        clearInterval(timer);
      } else {
        setCount(Math.floor(current));
      }
    }, 15);
    return () => clearInterval(timer);
  }, [inView, target]);
  return count;
}

function CounterSection() {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setInView(true);
    }, { threshold: 0.5 });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const clients = useCounter(100, inView);
  const indirect = useCounter(1000, inView);

  return (
    <div className="container-fluid py-2" style={{ backgroundColor: '#e9fcff' }} ref={ref}>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 col-md-12 mb-3">
            <div className="d-flex align-items-center">
              <div className="text-center">
                <span className="fw-bold" style={{ fontSize: '10rem', lineHeight: 1, color: '#00aaff' }}>10</span>
              </div>
              <div className="ms-3 d-flex flex-column justify-content-center" style={{ lineHeight: 1.2 }}>
                <p className="fw-bold text-muted mb-0" style={{ opacity: 0.5 }}>A DECADE</p>
                <p className="fw-bold text-muted mb-0" style={{ opacity: 0.5 }}>OF DEPLOYMENT</p>
                <p className="fw-bold text-muted mb-0" style={{ opacity: 0.5 }}>MASTERY</p>
              </div>
            </div>
            <h1 className="ms-3 mt-3">Pioneering the <span style={{ color: '#00aaff' }}><br /><strong>DevOps</strong></span> Culture</h1>
          </div>
          <div className="col-lg-3 col-md-6 mb-3 text-center">
            <h4 style={{ fontSize: '65px', fontWeight: 'normal', color: '#00aaff' }}>5</h4>
            <p className="fw-bold text-muted">TECHNOLOGY PARTNERSHIP</p>
            <h4 style={{ display: 'inline', fontSize: '65px', fontWeight: 'normal', color: '#00aaff' }}>{clients}</h4>
            <span style={{ fontSize: '4rem', fontWeight: 'normal', color: '#00aaff' }}>+</span>
            <p className="fw-bold text-muted">DIRECT CLIENTS</p>
          </div>
          <div className="col-lg-3 col-md-6 mb-3 text-center">
            <h4 style={{ fontSize: '65px', fontWeight: 'normal', color: '#00aaff' }}>11</h4>
            <p className="fw-bold text-muted">WHITELABEL SOLUTIONS</p>
            <h4 style={{ display: 'inline', fontSize: '65px', fontWeight: 'normal', color: '#00aaff' }}>{indirect}</h4>
            <span style={{ fontSize: '4rem', fontWeight: 'normal', color: '#00aaff' }}>+</span>
            <p className="fw-bold text-muted">INDIRECT CLIENTS</p>
          </div>
        </div>
      </div>
    </div>
  );
}

function Home() {
  const [activeTab, setActiveTab] = useState('php');
  const [formData, setFormData] = useState({ fullName: '', email: '', company: '', inquiry: '' });
  const [formSent, setFormSent] = useState(false);
  const logoTrackRef = useRef(null);
  const animFrameRef = useRef(null);
  const positionRef = useRef(0);

  // Infinite logo scroll
  useEffect(() => {
    const track = logoTrackRef.current;
    if (!track) return;
    const animate = () => {
      positionRef.current -= 0.5;
      if (Math.abs(positionRef.current) >= track.scrollWidth / 2) {
        positionRef.current = 0;
      }
      track.style.left = positionRef.current + 'px';
      animFrameRef.current = requestAnimationFrame(animate);
    };
    animFrameRef.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animFrameRef.current);
  }, []);

  // Bootstrap hero carousel init
  useEffect(() => {
    const carouselEl = document.getElementById('heroCarousel');
    if (carouselEl && window.bootstrap) {
      const carousel = new window.bootstrap.Carousel(carouselEl, { interval: 3000, ride: true });
      carouselEl.addEventListener('mouseenter', () => carousel.pause());
      carouselEl.addEventListener('mouseleave', () => carousel.cycle());
    }
  }, []);

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const fd = new FormData(e.target);
    const res = await fetch('https://api.web3forms.com/submit', { method: 'POST', body: fd });
    const result = await res.json();
    if (result.success) setFormSent(true);
  };

  return (
    <>
      <TopStrip />
      <Navbar />

      {/* ===== HERO CAROUSEL ===== */}
      <section className="home-hero-section">
        <div id="heroCarousel" className="carousel slide carousel-fade">
          <div className="carousel-inner">
            {heroSlides.map((slide, i) => (
              <div className={`carousel-item ${i === 0 ? 'active' : ''}`} key={i}>
                <Link to={slide.link}>
                  <img src={slide.desktop} className="home-hero-img d-none d-md-block"
                    loading={i === 0 ? 'eager' : 'lazy'} alt={slide.alt} width="1600" height="520" />
                </Link>
                <img src={slide.mobile} className="d-md-none d-block img-fluid"
                  loading={i === 0 ? 'eager' : 'lazy'} alt={slide.alt} width="768" height="1000" />
              </div>
            ))}
          </div>
        </div>
        <div className="carousel-indicators home-hero-indicators hero-indicators position-static mt-2">
          {heroSlides.map((_, i) => (
            <button key={i} type="button" data-bs-target="#heroCarousel" data-bs-slide-to={i}
              className={i === 0 ? 'active' : ''}></button>
          ))}
        </div>
      </section>
      <br />

      {/* ===== AFTER HERO TEXT ===== */}
      <div className="text-center px-3 px-md-5 mx-auto content-section" style={{ maxWidth: '100%' }}>
        <h2 className="fw-semibold mb-3">
          Dedicated DevOps <br />
          - <span className="text-uppercase" style={{ color: '#00aaff' }}>Invincible Infrastructure</span> - <br />
          Engineered by DDevOps
        </h2>
        <p className="content-line text-muted mx-auto mb-4">
          Stop worrying about downtime. We build self-healing, scalable cloud platforms so you can focus entirely on your core business.
        </p>
        <h4 className="fw-bold mb-3">You Code. <span style={{ color: '#00aaff' }}>We Operate.</span></h4>
        <div className="mt-3 d-flex justify-content-center gap-3 flex-wrap">
          <Link to="/contact" className="btn btn-outline-info px-4">Talk to an Architect</Link>
          <a href="https://ddevops.academy/" className="btn btn-info text-white px-4">Explore Our Academy</a>
        </div>
      </div>

      {/* ===== FEATURE CARD SWIPER ===== */}
      <div className="container mt-5">
        <Swiper
          modules={[Autoplay, Pagination]}
          slidesPerView={1}
          spaceBetween={20}
          loop={true}
          autoplay={{ delay: 3500, disableOnInteraction: false }}
          pagination={{ clickable: true }}
          breakpoints={{ 768: { slidesPerView: 2, spaceBetween: 25 }, 992: { slidesPerView: 3, spaceBetween: 30 } }}
          className="feature-swiper pb-5"
        >
          {featureCards.map((card, i) => (
            <SwiperSlide key={i}>
              <div className="feature-card text-center h-100">
                <img src={card.img} loading="lazy" className="card-icon floating-icon" alt={card.title} />
                <h5>{card.title}</h5>
                <p>{card.desc}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* ===== BEYOND HOSTING HEADING ===== */}
      <div className="container-fluid mx-auto py-5 circle-behind bg-logo-left">
        <div className="row justify-content-center text-center">
          <div className="col-lg-8 col-md-10 col-sm-12">
            <h1 className="fw-bold">Beyond Hosting A Partner in Growth</h1>
            <p className="fw-bold text-muted">
              Don't settle for shared hosting. We provide fully managed, high-performance cloud environments tailored to your budget—whether on AWS, Azure, or our dedicated servers.
            </p>
          </div>
        </div>
      </div>

      {/* ===== CARE SECTION ===== */}
      <div className="container mb-3" data-aos="fade-up">
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-12 my-4 bg-watermark" data-aos="fade-up">
            <div className="d-flex align-items-start my-4">
              <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 32 32" className="me-3 mt-1" style={{ color: '#00aeef' }}>
                <path fill="currentColor" d="M30 23v-2h-2.09a5.96 5.96 0 0 0-1.024-2.47l1.478-1.48l-1.414-1.414l-1.479 1.479A5.96 5.96 0 0 0 23 16.09V14h-2v2.09a5.96 5.96 0 0 0-2.47 1.024l-1.48-1.478l-1.414 1.414l1.479 1.479A6 6 0 0 0 16.09 21H14v2h2.09a6 6 0 0 0 1.024 2.47l-1.478 1.48l1.414 1.414l1.479-1.479A5.96 5.96 0 0 0 21 27.91V30h2v-2.09a5.96 5.96 0 0 0 2.47-1.024l1.48 1.478l1.414-1.414l-1.479-1.479A5.96 5.96 0 0 0 27.91 23Zm-8 3a4 4 0 1 1 4-4a4.005 4.005 0 0 1-4 4" /><path fill="currentColor" d="M28 6a2 2 0 0 0-2-2h-4V2h-2v2h-8V2h-2v2H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h4v-2H6V6h4v2h2V6h8v2h2V6h4v6h2Z" />
              </svg>
              <div>
                <strong className="fs-5 d-block">The "White-Glove" Tooling Suite</strong>
                <p className="mb-0 mt-2">Dedicated support deserves dedicated tooling. We equip your team with industry-standard dashboards and management tools, giving you full visibility without the administrative headache.</p>
              </div>
            </div>
            <div className="d-flex align-items-start my-4">
              <svg xmlns="http://www.w3.org/2000/svg" width="90" height="100" viewBox="0 0 24 24" className="me-3 mt-1" style={{ color: '#00aeef' }}>
                <path fill="currentColor" d="M22.5 14.5a2 2 0 0 0-2-2h-6a2 2 0 0 0-2 2h-3v-3h2.33A3.66 3.66 0 0 0 13 4.37a5 5 0 0 0-9.43 1.28a3 3 0 0 0 .93 5.85h3v8a1 1 0 0 0 1 1h4a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-2a2 2 0 0 0-.28-1a2 2 0 0 0 .28-1Zm-18-5a1 1 0 0 1 0-2a1 1 0 0 0 1-1a3 3 0 0 1 5.84-1a1 1 0 0 0 .78.66a1.65 1.65 0 0 1 1.38 1.67a1.67 1.67 0 0 1-1.67 1.67Zm8 9h-3v-2h3a2 2 0 0 0 .28 1a2 2 0 0 0-.28 1m2 2v-2h6v2Zm0-4v-2h6v2Z" />
              </svg>
              <div>
                <strong className="fs-5 d-block">Elastic Scalability</strong>
                <p className="mb-0 mt-2">Pay only for the resources you consume. Our dynamic scaling ensures you handle Black Friday traffic spikes without paying for idle servers on quiet days.</p>
              </div>
            </div>
            <div className="d-flex align-items-start my-4">
              <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 24 24" className="me-3 mt-1" style={{ color: '#00aeef' }}>
                <path fill="none" stroke="currentColor" strokeWidth="2" d="M12 22s-9-4-9-11V5l9-3l9 3v6c0 7-9 11-9 11Zm0-8a3 3 0 1 0 0-6a3 3 0 0 0 0 6Zm0-6V5m0 12v-3m-6-3h3m6 0h3M8 7l2 2m4 4l2 2m0-8l-2 2m-4 4l-2 2" />
              </svg>
              <div>
                <strong className="fs-5 d-block">Fortified DevSecOps</strong>
                <p className="mt-2 mb-0">Security isn't an afterthought; it's baked into our code. From DDoS protection to automated compliance patches, we keep your data behind an ironclad shield.</p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 d-flex align-items-center" data-aos="fade-up">
            <img src={hostingPartner} alt="Hosting Partner" loading="lazy" className="img-fluid w-100" style={{ objectFit: 'cover', maxHeight: '400px' }} />
          </div>
        </div>
      </div>

      {/* ===== COUNTER SECTION ===== */}
      <CounterSection />

      {/* JOIN MORE THAN PARAGRAPH */}
      <div className="row">
        <div className="col-12 my-4 text-center">
          <div className="container" style={{ maxWidth: '600px' }}>
            <h6 className="fw-normal" style={{ fontSize: '1rem', fontFamily: "'Lato', sans-serif" }}>
              Join 100+ Enterprises that trust <strong style={{ color: '#00aeef' }}>DDevOps</strong> to transform their delivery pipelines. We don't just maintain servers; we keep businesses on a continuous path of evolution.
            </h6>
          </div>
        </div>
      </div>

      {/* ===== ENGINEERING CAPABILITIES HEADING ===== */}
      <div className="row" style={{ marginTop: '5rem' }}>
        <div className="col-lg-12 my-4">
          <div className="container text-center">
            <div className="circle-behind">
              <h4 className="fw-bold fs-2 top top-line">Engineering Capabilities</h4>
            </div>
            <p className="fw-bold text-muted">Beyond simple hosting. We architect resilient, high-velocity platforms.</p>
          </div>
        </div>
      </div>

      {/* ===== 3RD CARD SLIDER (Slick replaced with Swiper) ===== */}
      <div className="container mt-5 px-3 px-md-4">
        <Swiper
          modules={[Autoplay]}
          slidesPerView={1}
          spaceBetween={20}
          loop={true}
          autoplay={{ delay: 1500, disableOnInteraction: false }}
          breakpoints={{ 992: { slidesPerView: 3, spaceBetween: 23 }, 768: { slidesPerView: 2, spaceBetween: 20 } }}
        >
          {engineeringCards.map((card, i) => (
            <SwiperSlide key={i} style={{ marginTop: '30px' }}>
              <div className="card custom-card py-4 text-center shadow-sm border-0 rounded-4">
                <img src={card.img} loading="lazy" alt={card.title} className="mx-auto mt-4 mb-3" style={{ height: '70px' }} />
                <h5 className="mb-2" style={{ color: '#2e2f30' }}>{card.title}</h5>
                <p className="text-muted px-3" style={{ fontSize: '0.75rem' }}>{card.desc}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* ===== DEVOPS SERVICE SECTION ===== */}
      <section id="Devops-service-section">
        <div className="container-fluid px-3 px-md-5 py-4 bg-logo-right" data-aos="fade-up">
          <h1 className="text-center top-line">The Continuous Evolution Engine.</h1>
          <p className="text-center mx-auto" style={{ fontSize: '1rem', maxWidth: '700px', fontFamily: 'sans-serif' }}>
            We don't just deploy we engineer a loop of constant improvement. From code commit to production monitoring, our pipeline ensures zero friction.
          </p>
        </div>
        <div className="container my-2">
          <div className="row align-items-center gx-4">
            <div className="col-lg-6 col-md-6 col-sm-12 d-flex align-items-center">
              <div className="list-group">
                {[
                  { title: 'Plan & Code', desc: 'Comprehensive architecture reviews, containerization strategies, and secure coding practices to ensure scalability and maintainability from the very first step.' },
                  { title: 'Build & Test', desc: 'Automated builds, unit testing, and advanced security scans integrated into CI/CD pipelines for faster delivery and reduced risk.' },
                  { title: 'Release', desc: 'Seamless Blue/Green and Canary deployments designed for zero downtime, enabling continuous delivery with confidence.' },
                  { title: 'Monitor', desc: 'Real-time observability powered by Grafana and ELK stack, offering proactive alerts, performance insights, and end-to-end visibility.' },
                ].map((item, i) => (
                  <a key={i} href="#!" className="list-group-item list-group-item-action custom-hover-item">
                    <h5 className="mb-1">{item.title}</h5>
                    <p className="mb-1">{item.desc}</p>
                  </a>
                ))}
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 d-flex justify-content-center pt-3" data-aos="fade-left">
              <img src={devopsImg} width="550" loading="lazy" className="img-fluid hide-on-mobile" alt="DevOps Loop" data-aos="fade-left" />
            </div>
          </div>
        </div>
      </section>

      {/* ===== TABS SECTION ===== */}
      <section id="tab-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-md-6">
              <h1 className="text-center top-line mt-5">Curated <span className="text-info">High-Performance</span> Stacks.</h1>
              <p className="text-center">We have benchmarked every combination. Whether you run PHP, Python, or Java, we deploy the exact caching and acceleration layer your code needs to fly.</p>
            </div>
          </div>
        </div>
        <div className="container w-75 my-5 custom-tab-container">
          <ul className="nav nav-tabs justify-content-center" role="tablist">
            {tabData.map((tab) => (
              <li className="nav-item" key={tab.id} role="presentation">
                <button
                  className={`nav-link ${activeTab === tab.id ? 'active' : ''}`}
                  onClick={() => setActiveTab(tab.id)}
                  type="button"
                >{tab.label}</button>
              </li>
            ))}
          </ul>
          <div className="tab-content p-3 border-top-0">
            {tabData.map((tab) => (
              <div key={tab.id} className={`tab-pane fade ${activeTab === tab.id ? 'show active' : ''}`}>
                <div className="row align-items-center">
                  <div className="col-lg-6 col-sm-12">
                    <p className="text-start" style={{ fontSize: '1rem' }}>{tab.content}</p>
                  </div>
                  <div className="col-lg-6 col-sm-12 text-center">
                    <img src={tab.img} loading="lazy" alt={tab.altImg} className="img-fluid" style={{ maxWidth: '140%', height: 'auto' }} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== TESTIMONIALS ===== */}
      <TestimonialsCarousel />

      {/* ===== CONTACT FORM SECTION ===== */}
      <section id="contact-form" style={{ backgroundColor: '#F9FAFB', paddingTop: '20px' }}>
        <div className="container my-0">
          <div className="row">
            <div className="col-md-6 col-sm-12">
              <h1 className="fw-semibold">Your <span style={{ color: '#00aaff' }}>Infrastructure</span> Deserves Elite Talent.</h1>
              <p className="mt-1">Stop gambling with freelancers. DDevOps provides engineers backed by the rigorous training of <strong>DDevOps Academy</strong>. We deploy battle-tested talent that integrates seamlessly with your team to drive stability, security, and speed.</p>
              <h5 className="mt-2 text-uppercase">Schedule Your Infrastructure Audit.</h5>
              {!formSent ? (
                <form action="https://api.web3forms.com/submit" method="POST" onSubmit={handleFormSubmit} className="mt-3" style={{ maxWidth: '500px' }}>
                  <input type="hidden" name="access_key" value="18c9761a-1b94-49be-9259-43d37e9c6067" />
                  <div className="row mb-3">
                    <div className="col-md-6" data-aos="fade-up">
                      <input type="text" name="fullName" className="form-control form-control-lg" placeholder="Full Name" required />
                    </div>
                    <div className="col-md-6 mt-3 mt-md-0" data-aos="fade-up" data-aos-delay="100">
                      <input type="email" name="email" className="form-control form-control-lg" placeholder="Email Address" required />
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-md-6" data-aos="fade-up" data-aos-delay="200">
                      <input type="text" name="company" className="form-control form-control-lg" placeholder="Company / Website" />
                    </div>
                    <div className="col-md-6 mt-3 mt-md-0" data-aos="fade-up" data-aos-delay="300">
                      <select name="inquiry" className="form-select form-select-lg" required>
                        <option value="" disabled defaultValue="">Your inquiry about</option>
                        <option value="devops">DevOps Services</option>
                        <option value="secops">SecOps Services</option>
                        <option value="wordpress">WordPress Development</option>
                        <option value="ecommerce">Ecommerce Solution</option>
                        <option value="webapp">Web & App Development</option>
                      </select>
                    </div>
                  </div>
                  <div className="mt-3" data-aos="fade-up" data-aos-delay="400">
                    <button type="submit" className="btn w-100 text-white" style={{ backgroundColor: '#00aaff', height: '50px', fontSize: '1.1rem' }}>
                      Get My Roadmap
                    </button>
                  </div>
                </form>
              ) : (
                <div className="alert alert-success mt-4">
                  <strong>Thank you!</strong> Your inquiry has been received. We'll be in touch shortly.
                </div>
              )}
            </div>
            <div className="col-lg-6 col-md-12 mt-4 mt-lg-0 text-center d-none d-md-block" data-aos="fade-left">
              <img src={contactGif} loading="lazy" alt="Contact Illustration" className="img-fluid" />
            </div>
          </div>
        </div>
      </section>

      {/* ===== LOGO SLIDER ===== */}
      <section className="logo-slider py-1 bg-white overflow-hidden mt-5">
        <h2 className="text-center text-uppercase top-line">The <span className="text-info fw-semibold">DDevOps</span> Toolkit</h2>
        <div className="container" style={{ margin: '1rem auto' }}>
          <div className="logo-wrapper" id="logoWrapper">
            <div className="logo-track" id="logoTrack" ref={logoTrackRef} style={{ position: 'relative' }}>
              {[...logoImages, ...logoImages].map((img, i) => (
                <img key={i} src={img} loading="lazy" className="slide-logo-img" alt={`Logo ${(i % 9) + 1}`} height="60" />
              ))}
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <HelpButton />
      <OfferPopup />
    </>
  );
}

export default Home;
